import './Home.css'

function Home() {
    return (
        <div className='text-center'>
            <h1>Dome Project Home Page</h1>
        </div>
    );
}

export default Home;